module.exports = __webpack_public_path__ + "img/113.ac2af5cb.jpg";